export const DriverLicenseFieldData = {
  formControlName: 'driverLicenseId',
  id: 'grit-driver-license-id',
  label: 'Driver licence or Govt ID',
  hint: 'This helps us verify your identity.',
  prefixIcon: {
    iconName: 'drive_eta',
  },
  requiredMessage:
    'Your driver license or Govt ID is required to process the application.',
  visibilityCanToggle: true,
};
